import { Box, Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import AHMIS, { API_URL } from '../../../api/api';
import AddAlertMessage from '../../../components/alert/Alert';
import DeleteRegisterRecordConformation from '../../../components/delete-register-record-conformation/DeleteRegisterRecordConformation';
import CustomModal from '../../../components/modal/CustomModal';
import MulDartaaSelect from '../../../components/mul-dartaa-select/MulDartaaSelect';
import SwarnaBinduRegister from '../../users/components/register/swarna-bindu-register/SwarnaBinduRegister';
import RegisterHeader from '../../../components/register-header/RegisterHeader';
import { ERROR, SOMETHING_WENT_WRONG, SUCCESS, SWARNABINDU } from '../../../utils/constants';
import { MUL_DARTA_NUMBERS_LIST } from '../../../utils/constants/forms';
import { DateUtils } from '../../../utils/dateUtils';
import { SessionStorage } from '../../../utils/storage/sessionStorage';

const SwarnaBinduForm = () => {
  const [showSwarnaBinduModal, setShowSwarnaBinduModal] = useState(false);
  const [modalDefaultValues, setModalDefaultValues] = useState({});
  const { register, handleSubmit, setValue, formState: { errors }, reset, watch } = useForm();
  const [totalSize, setTotalSize] = useState();
  const [swarnaBinduDataTable, setSwarnaBinduDataTable] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [mulDartaaOptions, setMulDartaaOptions] = useState([]);
  const { fromDate, toDate, searchParams } = useSelector((state) => state.dateReducer);
  const { rowsPerPage, pageNumber } = useSelector((state) => state.searchFilter);

  const openSwarnaBinduModal = () => {
    setShowSwarnaBinduModal(true);
  };

  const closeSwarnaBinduModal = () => {
    reset();
    setShowSwarnaBinduModal(false);
    setModalDefaultValues();
  };

  const submitSwarnaBinduForm = (data) => {
    if (modalDefaultValues?.id) {
      data.id = modalDefaultValues.id;
    }
    AHMIS.post(API_URL.swarnaBindu, data)
      .then((response) => {
        if (response.data.type === "success") {
          closeSwarnaBinduModal();
          getSwarnaBinduData(fromDate, toDate);
        }
        AddAlertMessage({ type: response.data.type, message: response.data.message });
      })
      .catch(() => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  useEffect(() => {
    if (fromDate && toDate) {
      getSwarnaBinduData(fromDate, toDate, searchParams);
    }
  }, [fromDate, toDate, searchParams, pageNumber, rowsPerPage]);

  const getSwarnaBinduData = (fromDate, toDate, searchParams) => {
    let url = `${API_URL.swarnaBindu}/fromDateRangeAndPage?fromDate=${fromDate}&toDate=${toDate}&pageNumber=${pageNumber}&rowSize=${rowsPerPage}`;
    if (searchParams) {
      url = url + "&searchParam=" + searchParams;
    }
    AHMIS.get(url)
      .then((response) => {
        let jsondata = response.data;
        setSwarnaBinduDataTable(jsondata?.data?.objectList || []);
        setTotalSize(jsondata?.data?.size);
      })
      .catch(() => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const swarnaBinduEdit = async (id) => {
    try {
      const response = await AHMIS.get(API_URL.swarnaBindu + "/" + id);
      const data = response?.data?.data;
      setModalDefaultValues(data);
      setShowSwarnaBinduModal(true);
      if (data) {
        Object.keys(data).forEach(key => {
          setValue(key, data[key]);
        });
      }
    } catch {
      AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
    }
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeleteId(null);
  };

  const onDeleteRow = (id) => {
    setShowDeleteModal(true);
    setDeleteId(id);
  };

  const deleteSwarnaBinduRow = (data) => {
    AHMIS.delete(API_URL.swarnaBindu + "/" + deleteId + "?deleteReason=" + data.deletedReason)
      .then(response => {
        let jsondata = response.data;
        if (jsondata.type === SUCCESS) {
          setShowDeleteModal(false);
          setDeleteId(null);
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
          getSwarnaBinduData(fromDate, toDate);
        } else {
          AddAlertMessage({ type: jsondata.type, message: jsondata.message });
        }
      })
      .catch(() => {
        AddAlertMessage({ type: ERROR, message: SOMETHING_WENT_WRONG });
      });
  };

  const onHeaderParamChange = (fromDate, toDate, searchParam) => {
    getSwarnaBinduData(fromDate, toDate, searchParam);
  };

  const attachMulDartaaOptions = () => {
    let mulDartaaOptions = [];
    AHMIS.get(API_URL.mulDartaaNumber + "?otherSewaType=13-1&fiscalYear=" + DateUtils.getCurrentFiscalYear())
      .then(response => {
        let data = response.data;
        SessionStorage.setItem(MUL_DARTA_NUMBERS_LIST, data);
        data.forEach(item => {
          mulDartaaOptions.push({ "value": item.mulDartaaNumber, "label": item.mulDartaaNumber + " (" + item.patientFirstName + " " + item.patientLastName + ")", id: item.id });
        });
        setMulDartaaOptions(mulDartaaOptions);
      });
  };

  useEffect(() => {
    attachMulDartaaOptions();
  }, []);

  return (
    <>
      <Box marginTop={3}>
        <RegisterHeader
          registerTitle="स्वर्णबिन्दु सेवा रजिष्टर"
          handleModalOpen={openSwarnaBinduModal}
          onHeaderParamChange={onHeaderParamChange}
          getRegisterData={getSwarnaBinduData}
          lazyLoading
          showSearchField
        />
      </Box>
      <CustomModal
        title="स्वर्णबिन्दु सेवा रजिष्टरमा नयाँ रेकर्ड थप्नुहोस्।"
        showModal={showSwarnaBinduModal}
        onModalSubmit={handleSubmit(submitSwarnaBinduForm)}
        onModalClose={closeSwarnaBinduModal}
        maxWidth="lg"
        fullScreen
      >
        <Grid container spacing={2} alignItems="center">
          <MulDartaaSelect
            mulDartaaOptions={mulDartaaOptions}
            defaultValues={modalDefaultValues}
            register={register}
            handleSubmit={handleSubmit}
            setValue={setValue}
            errors={errors}
            watch={watch}
            registerConstant={SWARNABINDU}
          />
        </Grid>
      </CustomModal>
      <DeleteRegisterRecordConformation
        showDeleteModal={showDeleteModal}
        closeDeleteModel={closeDeleteModal}
        deleteRecord={deleteSwarnaBinduRow}
      />
      <Box mt={2}>
        <SwarnaBinduRegister
          onEditRow={swarnaBinduEdit}
          tableData={swarnaBinduDataTable}
          deleteRow={onDeleteRow}
          totalSize={totalSize}
        />
      </Box>
    </>
  );
};

export default SwarnaBinduForm;
